import React, { Component } from 'react'
import { gql, graphql } from 'react-apollo'
import { Layout, Col, Row } from 'antd'
import CardObj from './Component/CardObj'
import HeaderTmp from '../Template/HeaderTmp'
import _orderBy from 'lodash/orderBy'
const { Content } = Layout

class Client extends Component {
    render() {
        if (!this.props.data.events) {
            return <div>Loading</div>
        }
        var { events } = this.props.data
        events = _orderBy(events, ['_id'], ['desc'])

        // var data = events.sort(function(a, b){
        //     if(a._id < b._id) return -1;
        //     if(a._id > b._id) return 1;
        //     return 0;
        // })

        return (
            <Layout style={{ background: "#ffffff" }}>
                <HeaderTmp />
                <Content style={{ padding: '0 50px', marginTop: 100 }}>
                    {/* <Row gutter={16}>
                        {events && events.filter(val => val.postFb).map(event => (
                            <Col key={event._id} xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }} lg={{ span: 6 }} style={{ marginTop: "20px" }}>
                                <CardObj name={event.title} event={event} />
                            </Col>
                        ))}
                    </Row> */}
                    <Row gutter={16}>
                        {events && events.map(event => (
                            <Col key={event._id} xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }} lg={{ span: 6 }} style={{ marginTop: "20px" }}>
                                <CardObj name={event.title} event={event} />
                            </Col>
                        ))}
                    </Row>
                </Content>
            </Layout>
        )
    }
}

const ClientQuery = gql`
    {
        events {
            event
            slug
            title
            logoFMImage
            date
            _id
        }
    }
`
const ClientWithData = graphql(ClientQuery)(Client)

export default ClientWithData


// WEBPACK FOOTER //
// ./src/Home/Home.js